module.exports = __webpack_public_path__ + "imgs/twitter2.c76d04aee3e11d6c26cd582d8461a123.svg";